module.exports = __webpack_public_path__ + "static/media/synopsis-hiw-image-1.018dc88f.png";